/**
 * Mark wrapping.
 */
export const markWrapping = () => {
  // Skip for now.
};
